'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dateFns = require('date-fns');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Modals = function () {
  function Modals() {
    _classCallCheck(this, Modals);
  }

  _createClass(Modals, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var modals = document.querySelectorAll('[data-modal]');
      var modalsArr = Array.prototype.slice.call(modals);

      if (!modals) return;

      modalsArr.forEach(function (modal) {
        var type = modal.dataset.modalType;
        _this.eventListeners(modal);

        if (type === 'auto') {
          _this.showAutoModal(modal);
        }
      });
    }
  }, {
    key: 'eventListeners',
    value: function eventListeners(modal) {
      var _this2 = this;

      var closeBtn = modal.querySelector('[data-modal-close]');

      closeBtn.addEventListener('click', function () {
        _this2.closeModal(modal);
      });

      modal.addEventListener('click', function (event) {
        var isOutside = !event.target.closest('.c-modal__container');

        if (isOutside) {
          _this2.closeModal(modal);
        }
      });
    }
  }, {
    key: 'showAutoModal',
    value: function showAutoModal(modal) {
      var version = modal.dataset.modalVersion;
      var interval = modal.dataset.modalInterval;
      var storedVersion = localStorage.getItem(version);

      if (storedVersion) {
        var previousTime = parseInt(storedVersion.replace('popup-', ''));
        var timestamp = Date.now();
        var days = (0, _dateFns.differenceInDays)(timestamp, previousTime);
        interval = typeof interval == 'undefined' ? 7 : parseInt(interval);

        if (interval <= 0) {
          setTimeout(function () {
            modal.classList.add('active');
          }, 10);
        } else if (days >= interval) {
          setTimeout(function () {
            modal.classList.add('active');
          }, 10);
        }
      } else {
        setTimeout(function () {
          modal.classList.add('active');
        }, 10);
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal(modal) {

      if (!modal) return;

      var type = modal.dataset.modalType;
      var cacheSlug = 'popup-cached-version';

      modal.classList.remove('active');

      if (type === 'auto') {
        var version = modal.dataset.modalVersion;
        var timestamp = Date.now();
        var cachedVersion = localStorage.getItem(cacheSlug);

        if (cachedVersion) {
          localStorage.removeItem(cachedVersion);
        }

        localStorage.setItem(version, timestamp);
        localStorage.setItem(cacheSlug, version);
      }
    }
  }]);

  return Modals;
}();

exports.default = Modals;


// WEBPACK FOOTER //
// ./scripts/util/modals.js